import StoresForm from './component';

export default StoresForm;
